import TicketTabs from "./ticket/tabs.es6";
import TicketProductSlider from "./ticket/productslider.es6";

// TICKET下層ページだけで使う操作を初期化する。
const ticketTabs = new TicketTabs();
const ticketProductSlider = new TicketProductSlider();
